import { forwardRef } from 'react';
import { Button } from '@/ui/Button';

export const SelectableButton = forwardRef(function SelectableButton({ children, onClick, selected }, ref) {  
  return (
    <Button ref={ref} shape="pill" size="sm" 
      color={selected ? 'black' : 'neutral'} 
      onClick={onClick}
    >{children}</Button>
  );    
});